const deleteAllCookies = () => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (name.trim().indexOf('ASPXAUTH') === -1) {
            // ASP Session no remove
            document.cookie = `${name.trim()}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    }
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
};
export default deleteAllCookies;
